module.exports = __webpack_public_path__ + "static/media/messenger1.b0ecae1b.svg";